import type { TFunction } from "i18next";
import type { CandidateInfo } from "../../client";
import UserAvatar from "../../components/UserAvatar";
import { formatUserName } from "../../utils/format/formatUserName";
import AnimatedVoteCount from "./AnimatedVoteCount";


interface LeadingCandidateBannerProps {
  leader: CandidateInfo;
  t: TFunction;
}

/** Gold "Currently Leading" strip at the top of the vote list. */
function LeadingCandidateBanner({ leader, t }: LeadingCandidateBannerProps) {
  return (
    <div className="mb-md flex shrink-0 items-center gap-[10px] rounded-[14px] bg-[image:var(--gradient-gold-warm)] px-lg py-md shadow-[0_3px_12px_var(--color-reward-warm-alpha-35)]">
      <UserAvatar user={leader} size={40} alt={formatUserName(leader).shortName} />
      <div className="min-w-0 flex-1">
        <div className="[font-family:'Rubik_One',sans-serif] text-[9px] font-normal tracking-[0.8px] text-black-alpha-50 uppercase">
          {t("Currently Leading")}
        </div>
        <div className="overflow-hidden text-ellipsis whitespace-nowrap [font-family:Lato,sans-serif] text-[14px] font-bold text-object-picker-surface">
          {formatUserName(leader).displayName}
        </div>
      </div>
      <div className="shrink-0 [font-family:'Rubik_One',sans-serif] text-[18px] font-normal text-object-picker-surface">
        <AnimatedVoteCount value={leader.votes_count} large />
      </div>
    </div>
  );
}

export default LeadingCandidateBanner;
